// src/App.js
import React, { useRef, useEffect, Suspense, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'; // Tambah useLocation
import { FaVolumeUp, FaVolumeMute } from 'react-icons/fa';

import Navbar from './components/Navbar';
import Banner from './components/Banner';
import Footer from './components/Footer';
import Loader from './components/Loader';
// import Promo from './components/Promo';
import EventDetail from './components/EventDetail';
import ChatbotContainer from './components/ChatbotContainer';
import WhatsAppChoiceButton from './components/WhatsAppChoiceButton'; 

// Lazy Loading
const Trips = React.lazy(() => import('./components/Trips'));
const Gallery = React.lazy(() => import('./components/Gallery'));
const WhyUs = React.lazy(() => import('./components/WhyUs'));
const Banda = React.lazy(() => import('./components/Banda'));
const Testimonial = React.lazy(() => import('./components/Testimonial'));
const Pic = React.lazy(() => import('./components/Pic'));
const Video = React.lazy(() => import('./components/Video'));
const Quote = React.lazy(() => import('./components/Quote'));
const TripDetail = React.lazy(() => import('./components/TripDetail'));
const About = React.lazy(() => import('./components/About'));
const Syaket = React.lazy(() => import('./components/Syaket'));
const DestinasiDetail = React.lazy(() => import('./components/DestinasiDetail'));

// Komponen pembungkus untuk mendapatkan akses ke useLocation
function AppContent({ loading, audioRef, isAudioPlaying, toggleAudio }) {
  const location = useLocation();
  
  // LOGIKA: Jika path adalah '/event/open-trip-mepo-2026', set isDirect jadi true
  const isDirectPage = location.pathname === '/event/open-trip-mepo-2026';

  return (
    <div className="App">
      {loading && <Loader />}
      <audio ref={audioRef} src="/audio/musik.mp3" loop></audio>

      {/* Tombol Toggle Audio */}
      <button 
        onClick={toggleAudio}
        className="audio-toggle-btn"
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          zIndex: 9999,
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3)',
          cursor: 'pointer',
          fontSize: '24px',
          color: '#fff',
          transition: 'all 0.3s ease'
        }}
        title={isAudioPlaying ? "Matikan Audio" : "Nyalakan Audio"}
      >
        {isAudioPlaying ? <FaVolumeUp /> : <FaVolumeMute />}
      </button>

      <Navbar />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={
            <>
              <Banner />
              <Trips />
              {/* <Promo /> */}
              <Gallery />
              <WhyUs />
              <Banda />
              <Testimonial />
              <Pic />
              <Video />
              <Quote />
            </>
          } />
          <Route path="/trip/:slug" element={<TripDetail />} />
          <Route path="/informasi" element={<About />} />
          <Route path="/syarat-ketentuan" element={<Syaket />} />
          <Route path="/destinasi/:slug" element={<DestinasiDetail />} />
          <Route path="/event/open-trip-mepo-2026" element={<EventDetail />} />
        </Routes>
      </Suspense>

      <Footer />

      {/* Gunakan isDirect berdasarkan pengecekan URL di atas */}
      <WhatsAppChoiceButton isDirect={isDirectPage} />

      <ChatbotContainer />
    </div>
  );
}

function App() {
  const audioRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 10000);

    if (audioRef.current) {
      audioRef.current.volume = 0.1;
      const playPromise = audioRef.current.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          setIsAudioPlaying(true);
        }).catch(error => {
          console.log("Autoplay diblokir browser.");
          setIsAudioPlaying(false);
        });
      }
    }
  }, []);

  const toggleAudio = () => {
    if (audioRef.current) {
      if (isAudioPlaying) {
        audioRef.current.pause();
        setIsAudioPlaying(false);
      } else {
        audioRef.current.play().then(() => {
          setIsAudioPlaying(true);
        }).catch(e => console.log(e));
      }
    }
  }

  return (
    <Router>
      <AppContent 
        loading={loading} 
        audioRef={audioRef} 
        isAudioPlaying={isAudioPlaying}
        toggleAudio={toggleAudio}
      />
    </Router>
  );
}

export default App;